import React from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { App } from './App';
import { AuthGate } from './auth/AuthGate';
import { msalConfig } from './auth/msalConfig';
// Self-hosted fonts (@fontsource) — no external Google-Fonts CDN dependency, so
// the deployed strict CSP can't silently starve the display/body faces and fall
// back to system-ui (a rubric ban). Weights match tailwind.config.js usage:
// Barlow 400/500/600/700 (body) + Big Shoulders Display 600/700/800 (headings).
import '@fontsource/barlow/400.css';
import '@fontsource/barlow/500.css';
import '@fontsource/barlow/600.css';
import '@fontsource/barlow/700.css';
import '@fontsource/big-shoulders-display/600.css';
import '@fontsource/big-shoulders-display/700.css';
import '@fontsource/big-shoulders-display/800.css';
import './i18n';
import './index.css';
import { applyTheme, watchSystemTheme } from './theme';
import floating from './lib/floating';

applyTheme();
watchSystemTheme();

const msalInstance = new PublicClientApplication(msalConfig);

// Set the active account after a successful login/redirect so token acquisition
// has an account to target.
const existing = msalInstance.getAllAccounts();
if (existing.length > 0) {
  msalInstance.setActiveAccount(existing[0] ?? null);
}
msalInstance.addEventCallback((event) => {
  if (
    event.eventType === EventType.LOGIN_SUCCESS &&
    event.payload &&
    'account' in event.payload &&
    event.payload.account
  ) {
    msalInstance.setActiveAccount(event.payload.account);
  }
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

floating(
  msalInstance.initialize().then(() => {
    ReactDOM.createRoot(rootElement).render(
      <React.StrictMode>
        <AuthGate instance={msalInstance}>
          <App />
        </AuthGate>
      </React.StrictMode>,
    );
  }),
);
